import { useEffect } from 'react';
import { Checkbox } from 'antd';

const CustomCheckbox = ({
  field,
  labelName,
}: {
  field: any;
  labelName: string;
}) => {
  useEffect(() => {
    field.onChange('No');
  }, []);

  return (
    <Checkbox
      type="checkbox"
      checked={field.value === 'Yes'}
      onChange={(e) => field.onChange(e.target.checked ? 'Yes' : 'No')}
    >
      {labelName}
    </Checkbox>
  );
};

export default CustomCheckbox;
